import { ensureAbsoluteUrl } from '../utils/url'

const SOCIAL_PLATFORMS = [
  { key: 'facebook_link', platform: 'facebook' },
  { key: 'instagram_link', platform: 'instagram' },
  { key: 'linkedin_link', platform: 'linkedin' },
  { key: 'youtube_link', platform: 'youtube' },
  { key: 'tiktok_link', platform: 'tiktok' },
]

export function buildSocialLinks(obj) {
  if (!obj) return []
  return SOCIAL_PLATFORMS.filter(({ key }) => obj[key]).map(
    ({ platform, key }) => ({
      platform,
      href: ensureAbsoluteUrl(obj[key]),
      label: platform,
    }),
  )
}

export { SOCIAL_PLATFORMS }

/**
 * Fields rendered by the Profile Settings social card, in design order.
 * Superset of SOCIAL_PLATFORMS — includes website_link, which is not a
 * social platform and so is excluded from buildSocialLinks above.
 */
export const SOCIAL_FIELDS = [
  {
    key: 'facebook_link',
    labelKey: 'users.edit.facebook_link',
    icon: 'facebook',
    placeholder: 'https://facebook.com/...',
  },
  {
    key: 'linkedin_link',
    labelKey: 'users.edit.linkedin_link',
    icon: 'linkedin',
    placeholder: 'https://linkedin.com/in/...',
  },
  {
    key: 'instagram_link',
    labelKey: 'users.edit.instagram_link',
    icon: 'instagram',
    placeholder: 'https://instagram.com/...',
  },
  {
    key: 'youtube_link',
    labelKey: 'users.edit.youtube_link',
    icon: 'youtube',
    placeholder: 'https://youtube.com/...',
  },
  {
    key: 'tiktok_link',
    labelKey: 'users.edit.tiktok_link',
    icon: 'tiktok',
    placeholder: 'https://tiktok.com/@...',
  },
  {
    key: 'website_link',
    labelKey: 'users.edit.website_link',
    icon: 'link',
    placeholder: 'https://...',
  },
]

/**
 * Client-side URL *shape* validation for the settings social inputs.
 *
 * There is no endpoint that verifies a link resolves or belongs to the user, so
 * this must never be presented as "verified" — only as a well-formed URL.
 *
 * @returns {'empty'|'valid'|'invalid'} 'empty' renders no indicator at all.
 */
export function socialUrlStatus(value) {
  const trimmed = (value ?? '').trim()
  if (!trimmed) return 'empty'
  try {
    const url = new URL(ensureAbsoluteUrl(trimmed))
    if (!/^https?:$/.test(url.protocol)) return 'invalid'
    // Require a dotted hostname so "http://foo" doesn't pass.
    return url.hostname.includes('.') ? 'valid' : 'invalid'
  } catch {
    return 'invalid'
  }
}
